/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchIndexStatistics { 
    /**
     * The index creation date
     */
    indexCreationDate?: Date;
    /**
     * The number of active documents in this index
     */
    indexNumberOfActiveDocuments?: number;
    /**
     * The number of deleted documents in this index
     */
    indexNumberOfDeletedDocuments?: number;
    /**
     * The UUID of the index
     */
    indexUuid?: string;
    /**
     * The count of the index size from count query
     */
    indexCount?: number;
}
